"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
exports.__esModule = true;
exports.RiskProvider = exports.RiskConsumer = void 0;
var React = __importStar(require("react"));
var enums_1 = require("../Common/utils/enums");
var reducer_1 = require("../Common/utils/reducer");
var track_1 = require("../Common/utils/track");
var RiskContext = React.createContext({
    authToken: undefined,
    client: undefined,
    experience: undefined,
    dispatch: function () { return null; },
    language: undefined,
    proxyOverride: undefined,
    riskBffConfig: undefined,
    state: reducer_1.initState(),
    riskClientAppName: undefined
});
exports.RiskConsumer = RiskContext.Consumer;
exports.RiskProvider = function (_a) {
    var authToken = _a.authToken, children = _a.children, client = _a.client, experience = _a.experience, language = _a.language, proxyOverride = _a.proxyOverride, riskBffConfig = _a.riskBffConfig, shouldUseRiskBff = _a.shouldUseRiskBff, _b = _a.riskClientAppName, riskClientAppName = _b === void 0 ? enums_1.RiskClientAppName.Default : _b;
    var _c = __read(React.useReducer(reducer_1.challengeReducer, reducer_1.challengeInitialState, reducer_1.initState), 2), state = _c[0], dispatch = _c[1];
    React.useEffect(function () {
        track_1.configureTracking(experience);
    }, []);
    return (React.createElement(RiskContext.Provider, { value: {
            authToken: authToken,
            client: client,
            dispatch: dispatch,
            experience: experience,
            language: language,
            proxyOverride: proxyOverride,
            riskBffConfig: riskBffConfig,
            state: state,
            shouldUseRiskBff: shouldUseRiskBff,
            riskClientAppName: riskClientAppName
        } }, children));
};
exports["default"] = RiskContext;
